import * as o from "react";
import { c as r } from "../createReactComponent-58f9bea8.mjs";
import { a as t, r as e } from "../textarea-1aaf762d.mjs";
import { T as B } from "../textarea-1aaf762d.mjs";
import "../property-9daa16cd.mjs";
import "../state-7560d4dc.mjs";
import "../query-d94c86d2.mjs";
import "../base-e16d29d8.mjs";
import "../class-map-2994e95e.mjs";
import "../if-defined-47693dfa.mjs";
import "../live-6c85dd15.mjs";
import "../purify.es-39f8036b.mjs";
import "../slot-controller-fa97ce97.mjs";
import "../icon-button-87ac6b5d.mjs";
import "../icon-c572aa57.mjs";
import "../tooltip-cb602d1f.mjs";
const F = r({ tagName: "ex-textarea", elementClass: t, react: o, events: { onBlur: "onBlur", onFocus: "onFocus", onChange: "onChange", onInput: "onInput" }, displayName: "ExTextarea", registerWebComponent: e });
export {
  F as ExTextarea,
  B as TextareaFooterType,
  e as register
};
